module.exports = __webpack_public_path__ + "img/05_kudo_13.985774a4.jpg";